import { defineStyle as o, defineStyleConfig as l } from "@chakra-ui/react";
const r = o({
  display: "inline-block",
  width: "100%",
  height: "auto",
  ".cls-1": {
    fill: "currentColor"
  },
  ".cls-2": {
    fill: "currentColor"
  }
}), c = o({
  grayscale: {
    ".cls-1": {
      color: "gray.700"
    },
    ".cls-2": {
      color: "gray.700"
    }
  },
  colour: {
    ".cls-1": {
      color: "#52A446"
    },
    ".cls-2": {
      color: "#FFD600"
    }
  }
}), e = l({
  baseStyle: r,
  variants: c,
  defaultProps: {
    variant: "colour"
  }
});
export {
  e as default
};
